import { REPORT_TEMPLATE, type IReportCardInfo, type TechRoadmapCardData } from '@/types';
import type { BaseCardService } from './abstract-base-card-service';
import { BaseCardServiceImpl, type BaseReportCardData } from './abstract-base-card-service';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ReportApiService } from '@/infrastructure/api-functions/report-api-service';
import _ from 'lodash'

export const TechRoadmapService = Symbol('TechRoadmapService');

export type TechRoadmapService = BaseCardService<TechRoadmapCardData>

@injectable()
export class TechRoadmapServiceImpl extends BaseCardServiceImpl<TechRoadmapCardData> implements TechRoadmapService {
    _modelData = {
        isLoading: false,
        isFailed: false,
        isSuccess: false,
        data: undefined,
    };

    templateType = REPORT_TEMPLATE.TECHNOLOGICAL_EVOLUTION_PATH;

    constructor(
        @inject(ReportApiService) _reportApiService: ReportApiService
    ) {
        super(
            _reportApiService
        );
    }

    private _generateRoadmapData(cardData: BaseReportCardData<IReportCardInfo>) {
        const cardInfo = cardData.data?.[REPORT_TEMPLATE.TECHNOLOGICAL_EVOLUTION_PATH];
        const roadmapData = cardInfo?.TECHNOLOGICAL_EVOLUTION_PATH_GPT.chart.CHART || [];
        const flagData = cardInfo?.TECHNOLOGICAL_EVOLUTION_PATH_GPT.flag_chart || [];
        flagData.forEach(item => {
            item.node_list.forEach(node => {
                node.nodeIndex = node.title + node.year.toString();
            });
        });

        const start = cardInfo?.TECHNOLOGICAL_EVOLUTION_PATH_GPT.chart.START;
        const end = cardInfo?.TECHNOLOGICAL_EVOLUTION_PATH_GPT.chart.END;

        const years = start && end ? _.range(start, end + 1) : [];

        return {
            roadmapData,
            flagData,
            years,
        }
    }

    updateFetchData(getUpdateValue: (v: BaseReportCardData<IReportCardInfo>) => BaseReportCardData<IReportCardInfo>): void {
        const updatedValue = getUpdateValue(_.omit(this.modelData, 'data'));

        const dataHaveFromUpdated = _.has(updatedValue, 'data')

        if (dataHaveFromUpdated) {
            this.update(modelData => ({
                ...modelData,
                ...updatedValue,
                data: this._generateRoadmapData(updatedValue),
            }));
        } else {
            this.update(m => ({
                ...m,
                ...updatedValue,
                data: m.data,
            }));
        }
    }
}
